/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { Stack } from '@fluentui/react/lib/Stack';
import { observer } from 'mobx-react';
import * as React from 'react';
import { SublistSynonymsCell } from 'src/luis/verticals/entityDetails/components/listEntityDetails/SublistSynonymsCell';
import { QnaMakerSynonymStore } from 'src/qnaMaker/core/stores/QnaMakerSynonymStore';

type QnaMakerSynonymGroupDetailsProps = {
    isInEditMode: boolean;
    onEditModeExit: () => void;
    isRemovingDisabled: boolean;
    synonymGroupData: QnaMakerSynonymStore;
    onEditSynonyms: (synonyms: string[]) => void;
};

export const QnaMakerSynonymGroupDetails = observer((props: QnaMakerSynonymGroupDetailsProps) => {
    const { isInEditMode, synonymGroupData, onEditSynonyms, onEditModeExit, isRemovingDisabled } = props;

    return (
        <Stack tokens={{ padding: '0 0 0 28px' }} styles={{ root: { marginTop: '10px' } }}>
            <SublistSynonymsCell
                onExitFocus={onEditModeExit}
                isRemovingDisabled={isRemovingDisabled}
                values={synonymGroupData?.alterations ?? []}
                isEditMode={isInEditMode && synonymGroupData?.alterations.length < 20}
                onAddValues={values => onEditSynonyms([...synonymGroupData?.alterations, ...values])}
                onRemoveValues={values => onEditSynonyms(synonymGroupData?.alterations.filter(v => values.some(value => value !== v)))}
            />
        </Stack>
    );
});
